import React from 'react';
import { Container, Tabs, Tab } from 'react-bootstrap';
import { FiFileText, FiDollarSign } from 'react-icons/fi';
import CobrarMesasView from './CobrarMesasView';
import PedidosEmitidosView from './PedidosEmitidosView';

const DashboardCajero = () => {
  return (
    <Container fluid className="p-4">
      <Tabs defaultActiveKey="pedidos" id="cajero-tabs" className="mb-3" fill>
        <Tab
          eventKey="pedidos"
          title={
            <>
              <FiFileText className="me-2" />
              Pedidos
            </>
          }
        >
          <PedidosEmitidosView />
        </Tab>
        <Tab
          eventKey="cobros"
          title={
            <>
              <FiDollarSign className="me-2" />
              Mesas para cobrar
            </>
          }
        >
          <CobrarMesasView />
        </Tab>
      </Tabs>
    </Container>
  );
};

export default DashboardCajero;
